import { CreateNewReportModal } from "./CreateNewReportModal";

export default CreateNewReportModal;
